<template>

  <div class="col-md-12 product-card">
    <b-skeleton v-if="!loaded" height="270" width="210"/>
    <div v-if="loaded && product.color">
      <a v-if="product.color"
         :href="url('/product/' + product.codice )"
         class="prod-scopri">
        <image-elm :elm="product"/>
      </a>
      <a v-if="!product.color"
         :href="url('/catalog/' + product.cod_macrofamiglia + '/' + product.cod_famiglia + '/' + product.cod_categoria + '/SC')"
         class="prod-scopri">
        <image-elm :elm="product"/>
      </a>
      <div class="card-body-prod">
        <!--      <p class="codart">{{product.cod_categoria}} {{product.cod_colore}}</p>-->
        <p class="codart">
          <cod-elm :elm="product"></cod-elm>
        </p>
        <p v-if="product.family.descrizione">{{ product.family.descrizione }}</p>
        <p v-if="product.color">{{ product.color.descrizione }}</p>
        <p v-if="product.category" class="category">{{ product.category.descrizione }}</p>
<!--        <a v-if="product.color"
           :href="url('/catalog/' + product.cod_macrofamiglia + '/' + product.cod_famiglia + '/' + product.cod_categoria + '/' + product.cod_colore )"
           class="prod-scopri">
          <span>{{ trans.get('public.explore') }}</span>
          <img :src="url('/media/icons/svg/arrow-right_white.svg')" alt="arrow"></a>
        <a v-if="!product.color"
           :href="url('/catalog/' + product.cod_macrofamiglia + '/' + product.cod_famiglia + '/' + product.cod_categoria + '/SC')"
           class="prod-scopri">
          <span>{{ trans.get('public.explore') }}</span>
          <img :src="url('/media/icons/svg/arrow-right_white.svg')" alt="arrow"></a>-->
        <a v-if="product.color"
           :href="url('/product/' + product.codice)"
           class="prod-scopri">
          <span>{{ trans.get('public.explore') }}</span>
          <img :src="url('/media/icons/svg/arrow-right_white.svg')" alt="arrow"></a>
        <a v-if="!product.color"
           :href="url('/catalog/' + product.cod_macrofamiglia + '/' + product.cod_famiglia + '/' + product.cod_categoria + '/SC')"
           class="prod-scopri">
          <span>{{ trans.get('public.explore') }}</span>
          <img :src="url('/media/icons/svg/arrow-right_white.svg')" alt="arrow"></a>
      </div>
    </div>
    <div v-if="loaded && !product.color">
      <image-elm :elm="product"/>
      <div class="card-body-prod">
        <!--      <p class="codart">{{product.cod_categoria}} {{product.cod_colore}}</p>-->
        <p class="codart">
          <cod-elm :elm="product"></cod-elm>
        </p>
        <p v-if="product.family.descrizione">{{ product.family.descrizione }}</p>
        <p v-if="product.color">{{ product.color.descrizione }}</p>
        <p v-if="product.category" class="category">{{ product.category.descrizione }}</p>
        <a v-if="product.color"
           :href="url('/catalog/' + product.cod_macrofamiglia + '/' + product.cod_famiglia + '/' + product.cod_categoria + '/' + product.cod_colore )"
           class="prod-scopri">
          <span>{{ trans.get('public.explore') }}</span>
          <img :src="url('/media/icons/svg/arrow-right_white.svg')" alt="arrow"></a>
        <a v-if="!product.color && product.category"
           :href="url('/catalog/' + product.cod_macrofamiglia + '/' + product.cod_famiglia + '/' + product.cod_categoria + '/SC')"
           class="prod-scopri">
          <span>{{ trans.get('public.explore') }}</span>
          <img :src="url('/media/icons/svg/arrow-right_white.svg')" alt="arrow"></a>
        <a v-if="!product.category"
           :href="url('/catalog/' + product.cod_macrofamiglia + '/' + product.cod_famiglia  + '/uncat-col/' + product.slug)"
           class="prod-scopri">
          <span>{{ trans.get('public.explore') }}</span>
          <img :src="url('/media/icons/svg/arrow-right_white.svg')" alt="arrow"></a>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "product-card",
  props: ['product'],
  data() {
    return {
      loaded: false,
    }
  },
  mounted() {
    setTimeout(el => {
      this.loaded = true
    }, 150)
  },
  methods: {},
  updated() {

  }
}
</script>

<style lang="scss" scoped>
.product-card {
  padding: 0;
  margin-bottom: 40px;
  font-size: 1rem;
  @media (min-width: 1921px) {
    font-size: var(--font-size-large);
  }

  .card-body-prod {
    display: flex;
    flex-direction: column;
    padding: 37px 27px;
    background-color: #2F2F34;
    min-height: 330px;
    @media (max-width: 576px) {
      display: flex;
      min-height: 375px;
      flex-direction: column;
      height: 65%;
    }

    .codart {
      margin-bottom: 22px;
    }

    .category {
      margin-top: 25px;
      color: #ABC932;
    }

    p:not(.codart) {
      text-transform: lowercase;

      &:first-letter {
        text-transform: uppercase;
      }
    }

    .prod-scopri {
      margin-top: auto;
      @media (max-width: 576px) {
        margin-top: auto;
      }
      display: flex;

      span {
        margin-left: auto;
        margin-right: 10px;
      }
    }
  }

}

</style>
